module.exports = __webpack_public_path__ + "img/Clear.bd8c7da5.png";